import { FieldDefinition, FieldBuilder } from '@zendra/shared';

FieldBuilder.setNamespace('Geographic');

export const WOODCERTIFICATIONDETAILTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.WoodCertificationDetailType.Name')
    .maxLength(400)
    .build(),
];

export const WOODCERTIFICATIONDETAILTYPE_CONFIG = {
  entityName: 'WoodCertificationDetailType',
  localizationKey: 'Geographic::Entity.WoodCertificationDetailType',
  fields: WOODCERTIFICATIONDETAILTYPE_FIELDS,
  permission: 'PlanningGeography.WoodCertificationDetailTypes',
  showInMenu: false,
  menuCategory: '',
  menuSubcategory: '',
};
